import React from "react";
// import Input from "@material-ui/core/Input";
import { Checkbox, FormControlLabel} from "@material-ui/core";
import CircularProgress from "@mui/material/CircularProgress";
import { Building, Globe, Phone } from "lucide-react";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";
import { Link } from "react-router-dom";
import SingleSelectNew from "../../components/SelectField/SingleSelectNew";
import SingleSelectSearch from "../../components/SelectField/SelectSearch";

const RegisterStep2 = (props) => {
  const stepId = 2;
  const {
    formState,
    handleInputChange,
    userRegister,
    industry,
    setErrorMessage,
    errorMessage,
    loading,
    onChangeCheckbox,
    state,
    error,
    peoples
  } = props;

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = validateAndGoNext();

    if (Object.keys(newErrors).length === 0) {
      userRegister(e);
    }
  };

  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    handleInputChange({ target: { name: "phoneNumber", value: value.slice(0, 10) } });
  };


  const validateAndGoNext = () => {
    const { companyName, phoneNumber, website, industry, peoples } = formState;
    const newErrors = {};

    if (!companyName?.trim())
      newErrors.companyName = "Company name is required.";
    if (!phoneNumber?.trim()) newErrors.phoneNumber = "Phone Number is required.";
    else if (phoneNumber.length !== 10) newErrors.phoneNumber = "Phone Number must be 10 digits.";
    if (!website?.trim()) newErrors.website = "Website is required.";

    if (!industry) newErrors.industry = "Industry is required.";
    if (!peoples)
      newErrors.peoples = "Enter the number of peoples in your company.";

    setErrorMessage(newErrors);
    return newErrors;
  };

  return (
    <div className="space-y-5 sm:space-y-6 py-4 w-full px-4 sm:px-0">
      <div className="space-y-4">
        <h3 className="text-lg font-medium">Business Details</h3>
        <p className="text-sm text-gray-500">
          This information helps us customize your experience.
        </p>

        <div className="space-y-2">
          <label htmlFor="phone" className="block text-sm font-medium">
            Phone Number
          </label>
          <div className="relative">
            <Phone className="absolute left-3 top-3 h-4 w-4 text-gray-400" />
            <Input
              fullWidth={true}
              disableUnderline={true}
              onChange={handlePhoneChange}
              value={formState.phoneNumber ? formState.phoneNumber : ""}
              className="pl-40"
              name="phoneNumber"
              maxLength={15}
              id="phoneNumber"
              placeholder="Phone Number"
              tabIndex={7}
            />
          </div>
          {errorMessage.phoneNumber && (
            <div className="small error color-danger">
              {errorMessage.phoneNumber}
            </div>
          )}
        </div>

        <div className="space-y-2">
          <label htmlFor="company" className="block text-sm font-medium">
            Company Name
          </label>
          <div className="relative">
            <Building className="absolute left-3 top-3 h-4 w-4 text-gray-400" />
            <Input
              fullWidth={true}
              disableUnderline={true}
              onChange={handleInputChange}
              value={formState.companyName ? formState.companyName : ""}
              className="pl-40"
              name="companyName"
              id="companyName"
              maxLength={50}
              placeholder="Company Name"
              tabIndex={8}
            />
          </div>
          {errorMessage.companyName && (
            <div className="small error color-danger">
              {errorMessage.companyName}
            </div>
          )}
        </div>

        <div className="space-y-2">
          <label htmlFor="industry" className="block text-sm font-medium">
            Industry
          </label>
          <SingleSelectSearch
            value={formState?.industry ? formState?.industry : ""}
            placeholder={"Select Industry"}
            className={"bg-white"}
            name={"industry"}
            onChange={(val) => handleInputChange(val, "industry")}
            options={industry}
            tabIndex={9}
          />
          {errorMessage.industry && (
            <div className="small error color-danger">
              {errorMessage.industry}
            </div>
          )}
        </div>

        <div className="space-y-2">
          <label htmlFor="website" className="block text-sm font-medium">
            Website
          </label>
          <div className="relative">
            <Globe className="absolute left-3 top-3 h-4 w-4 text-gray-400" />
            <Input
              fullWidth={true}
              disableUnderline={true}
              onChange={handleInputChange}
              value={formState.website ? formState.website : ""}
              className="pl-40"
              name="website"
              id="website"
              placeholder="Website"
              tabIndex={10}
            />
          </div>
          {errorMessage.website && (
            <div className="small error color-danger">
              {errorMessage.website}
            </div>
          )}
        </div>

        <div className="space-y-2">
          <label htmlFor="companySize" className="block text-sm font-medium">
            Company Size
          </label>
          <SingleSelectNew
            value={formState?.peoples ? formState?.peoples : ""}
            placeholder={"How many people in your company"}
            name={"peoples"}
            className={"bg-white"}
            onChange={(val) => handleInputChange(val, "peoples")}
            options={peoples}
            tabIndex={11}
          />
        </div>
        {errorMessage.peoples && (
          <div className="small error color-danger">{errorMessage.peoples}</div>
        )}

        <div className="space-y-2">
          <label htmlFor="companySize" className="block text-sm font-medium">
            Promo Code (Optional)
          </label>
            <Input
              fullWidth={true}
              disableUnderline={true}
              onChange={handleInputChange}
              value={formState?.promo ? formState?.promo : ""}
              name="promo"
              id="promo"
              placeholder="Promo Code"
              tabIndex={12}
            />
        </div>
      </div>
      <div className="loginbottom">
        <FormControlLabel
        className="d-flex flex-center"
          control={
            <Checkbox
              value="yes"
              color="primary"
              checked={Boolean(state?.terms ? state?.terms : false)}
              onChange={onChangeCheckbox}
              tabIndex={13}
            />
          }
          label={
            <div className="text-center text-sm text-gray-500">
              I confirm that I have read and agree to the{" "}
              <Link
                to="/terms-of-use"
                target="_blank"
                rel="noopener noreferrer"
                className="text-green-600 hover:text-green-800 font-medium"
              >
                Terms and Conditions
              </Link>
              {" "}and{" "}
              <Link
                to="/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
                className="text-green-600 hover:text-green-800 font-medium"
              >
                Privacy Policy
              </Link>
              .
            </div>
          }
        />
      </div>
      {error !== "" && error !== "Email is already registered" && <div className="small error color-danger">{error}</div>}
      <div className="pt-4">
        <Button
          onClick={handleSubmit}
          type="button"
          className="w-full"
          size="lg"
          tabIndex={14}
        >
          {loading ? (
            <CircularProgress size={28} style={{ color: "white" }} />
          ) : (
            "Complete Setup"
          )}
        </Button>
      </div>
    </div>
  );
};

export default RegisterStep2;
